export const fixedBody = (idEvent) => {
  return {
    eventId: idEvent,
    headerImgUrl:
      "https://s3.amazonaws.com/bucket.app.eventos/gallery/8029badb-d64c-4af8-9f52-59b60e346767/2025/1c5b3e18-d43a-4dff-8662-fe4d47c53df2.webp?AWSAccessKeyId=AKIAJ2EWX2HWZM4NBALA&Expires=2139125200&Signature=P8sOhgmFJqBSnXFxib0SzVW5mfs%3D",
    details: JSON.stringify({
      en: '<h5><span style="color: #34495e;">ESTAD&Atilde;O SUMMIT IMOBILI&Aacute;RIO</span></h5>\n<p>Inteegra TEC, S&atilde;o Paulo - SP</p>\n<p><span style="color: #000eff;"><a style="color: #000eff;" href="https://www.google.com/maps/place/Unibes+Cultural/@-23.5511273,-46.6783153,17z/data=!3m1!4b1!4m6!3m5!1s0x94ce578e458b5153:0x465a1a836ccd89a1!8m2!3d-23.5511273!4d-46.6783153!16s%2Fg%2F11dz_y05nj?entry=ttu&amp;g_ep=EgoyMDI1MDMxOS4xIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener">Veja a Localiza&ccedil;&atilde;o</a></span></p>\n<p>14 de Maio</p>\n<p>10:30 &agrave;s 16h</p>',
      es: '<h5><span style="color: #34495e;">ESTAD&Atilde;O SUMMIT IMOBILI&Aacute;RIO</span></h5>\n<p>Inteegra TEC, S&atilde;o Paulo - SP</p>\n<p><span style="color: #000eff;"><a style="color: #000eff;" href="https://www.google.com/maps/place/Unibes+Cultural/@-23.5511273,-46.6783153,17z/data=!3m1!4b1!4m6!3m5!1s0x94ce578e458b5153:0x465a1a836ccd89a1!8m2!3d-23.5511273!4d-46.6783153!16s%2Fg%2F11dz_y05nj?entry=ttu&amp;g_ep=EgoyMDI1MDMxOS4xIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener">Veja a Localiza&ccedil;&atilde;o</a></span></p>\n<p>14 de Maio</p>\n<p>10:30 &agrave;s 16h</p>',
      pt: '<h5><span style="color: #34495e;">ESTAD&Atilde;O SUMMIT IMOBILI&Aacute;RIO</span></h5>\n<p>Inteegra TEC, S&atilde;o Paulo - SP</p>\n<p><span style="color: #000eff;"><a style="color: #000eff;" href="https://www.google.com/maps/place/Unibes+Cultural/@-23.5511273,-46.6783153,17z/data=!3m1!4b1!4m6!3m5!1s0x94ce578e458b5153:0x465a1a836ccd89a1!8m2!3d-23.5511273!4d-46.6783153!16s%2Fg%2F11dz_y05nj?entry=ttu&amp;g_ep=EgoyMDI1MDMxOS4xIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener">Veja a Localiza&ccedil;&atilde;o</a></span></p>\n<p>14 de Maio</p>\n<p>10:30 &agrave;s 16h</p>',
    }),
    description: JSON.stringify({
      en: '<h3>As tend&ecirc;ncias que impactam o presente e moldam o futuro</h3>\n<p>O evento integra a programa&ccedil;&atilde;o comemorativa dos 150 anos do Estad&atilde;o, com o objetivo de explorar as principais inova&ccedil;&otilde;es tecnol&oacute;gicas que j&aacute; est&atilde;o transformando a sociedade e os setores produtivos e, sobretudo, oferecer um olhar vision&aacute;rio para os desafios e as oportunidades dos pr&oacute;ximos anos.</p>\n<p>Cancelamento de inscri&ccedil;&otilde;es</p>\n<ul>\n<li style="color: #000000;"><span style="color: #000000;">Para&nbsp;cancelamento&nbsp;at&eacute; 30/04/25 ser&aacute; devolvido o valor total do ingresso.</span></li>\n<li style="color: #000000;"><span style="color: #000000;">Para&nbsp;cancelamento&nbsp;at&eacute; 10/05/25 ser&aacute; devolvido valor parcial&nbsp;de 50%&nbsp;do ingresso.</span></li>\n<li style="color: #000000;"><span style="color: #000000;">Ap&oacute;s dia 11/05/25 n&atilde;o haver&aacute; devolu&ccedil;&atilde;o.</span></li>\n</ul>',
      es: '<h3>As tend&ecirc;ncias que impactam o presente e moldam o futuro</h3>\n<p>O evento integra a programa&ccedil;&atilde;o comemorativa dos 150 anos do Estad&atilde;o, com o objetivo de explorar as principais inova&ccedil;&otilde;es tecnol&oacute;gicas que j&aacute; est&atilde;o transformando a sociedade e os setores produtivos e, sobretudo, oferecer um olhar vision&aacute;rio para os desafios e as oportunidades dos pr&oacute;ximos anos.</p>\n<p>Cancelamento de inscri&ccedil;&otilde;es</p>\n<ul>\n<li style="color: #000000;"><span style="color: #000000;">Para&nbsp;cancelamento&nbsp;at&eacute; 30/04/25 ser&aacute; devolvido o valor total do ingresso.</span></li>\n<li style="color: #000000;"><span style="color: #000000;">Para&nbsp;cancelamento&nbsp;at&eacute; 10/05/25 ser&aacute; devolvido valor parcial&nbsp;de 50%&nbsp;do ingresso.</span></li>\n<li style="color: #000000;"><span style="color: #000000;">Ap&oacute;s dia 11/05/25 n&atilde;o haver&aacute; devolu&ccedil;&atilde;o.</span></li>\n</ul>',
      pt: '<h3>As tend&ecirc;ncias que impactam o presente e moldam o futuro</h3>\n<p>O evento integra a programa&ccedil;&atilde;o comemorativa dos 150 anos do Estad&atilde;o, com o objetivo de explorar as principais inova&ccedil;&otilde;es tecnol&oacute;gicas que j&aacute; est&atilde;o transformando a sociedade e os setores produtivos e, sobretudo, oferecer um olhar vision&aacute;rio para os desafios e as oportunidades dos pr&oacute;ximos anos.</p>\n<p>Cancelamento de inscri&ccedil;&otilde;es</p>\n<ul>\n<li style="color: #000000;"><span style="color: #000000;">Para&nbsp;cancelamento&nbsp;at&eacute; 30/04/25 ser&aacute; devolvido o valor total do ingresso.</span></li>\n<li style="color: #000000;"><span style="color: #000000;">Para&nbsp;cancelamento&nbsp;at&eacute; 10/05/25 ser&aacute; devolvido valor parcial&nbsp;de 50%&nbsp;do ingresso.</span></li>\n<li style="color: #000000;"><span style="color: #000000;">Ap&oacute;s dia 11/05/25 n&atilde;o haver&aacute; devolu&ccedil;&atilde;o.</span></li>\n</ul>',
    }),
    fields: JSON.stringify({
      city: {
        type: "city",
        error: {
          pt: "O campo city é obrigatório",
        },
        label: {
          pt: "Cidade",
        },
        order: 8,
        required: true,
      },
      name: {
        type: "alphabet",
        error: {
          pt: "O campo nome é obrigatório",
        },
        label: {
          en: "Name",
          es: "Nombre",
          pt: "Nome",
        },
        order: 1,
        required: true,
      },
      role: {
        type: "default",
        error: {
          pt: "O campo cargo é obrigatório",
        },
        label: {
          pt: "Cargo",
        },
        order: 10,
        required: true,
      },
      email: {
        type: "email",
        error: {
          pt: "Email inválido",
        },
        label: {
          pt: "Email",
        },
        order: 4,
        required: true,
      },
      state: {
        type: "state",
        error: {
          pt: "O campo nome é obrigatório",
        },
        label: {
          pt: "Estado",
        },
        order: 7,
        required: true,
      },
      term1: {
        type: "checkbox",
        error: {
          pt: "Não foi aceito o compartilhamento.",
        },
        label: {
          pt: "Concordo que o Grupo Estado compartilhe meus dados pessoais com outra entidades do Grupo Estado de acordo com o descrito na Política de Privacidade do Grupo Estado.",
        },
        order: 11,
        required: true,
      },
      term2: {
        type: "checkbox",
        error: {
          pt: "Não foi declarado que li e concordo.",
        },
        label: {
          pt: "Declaro que li e concordo com os Termos de Uso do Estadão",
        },
        order: 12,
        required: true,
      },
      term3: {
        type: "checkbox",
        error: {
          pt: "Não foi aceito receber comunicações adicionais",
        },
        label: {
          pt: "Gostaria de receber comunicações adicionais do Grupo Estado (por telefone e/ou e-mail).  Eu concordo que o Grupo Estado. pode usar meu nome e dados de contato para me enviar comunicações sobre os produtos do Grupo Estado, conteúdos e ofertas de parceiros de acordo com a Política de Privacidade do Grupo Estado.",
        },
        order: 13,
        required: true,
      },
      term4: {
        type: "checkbox",
        error: {
          pt: "Não foi aceito os termos de serviço",
        },
        label: {
          pt: "Aceito os termos de serviço",
        },
        order: 13,
        required: true,
      },
      mobile: {
        type: "mobile",
        error: {
          pt: "Número de celular inválido",
        },
        label: {
          pt: "Celular",
        },
        order: 5,
        required: true,
      },
      address: {
        type: "default",
        error: {
          pt: "O campo endereço é obrigatório",
        },
        label: {
          pt: "Endereço",
        },
        order: 6,
        required: true,
      },
      company: {
        type: "default",
        error: {
          pt: "O campo empresa é obrigatório",
        },
        label: {
          pt: "Empresa",
        },
        order: 9,
        required: true,
      },
      document: {
        type: "cpf",
        error: {
          pt: "CPF inválido",
        },
        label: {
          pt: "CPF",
        },
        order: 3,
        required: true,
      },
      namebadge: {
        id: 2,
        type: "badge",
        error: {
          pt: "O campo nome para crachá é obrigatório",
        },
        label: {
          pt: "Nome para crachá",
        },
        order: 2,
        required: true,
      },
    }),
    language: JSON.stringify({
      codes: ["pt"],
    }),
    creditCard: JSON.stringify({
      title: {
        pt: "Cartão de crédito",
      },
      fields: {
        code: {
          error: {
            pt: "Em cartão de crédito, o campo código de segurança não foi preenchido!",
          },
          label: {
            pt: "Código de segurança",
          },
          order: 5,
        },
        name: {
          error: {
            pt: "Em cartão de crédito, o campo nome impresso no cartão não foi preenchido!",
          },
          label: {
            pt: "Nome impresso no cartão",
          },
          order: 2,
        },
        number: {
          error: {
            pt: "Em cartão de crédito, o valor do campo número do cartão é inválido!",
          },
          label: {
            pt: "Número do cartão",
          },
          order: 1,
        },
        country: {
          error: {
            pt: "Em cartão de crédito, o campo país não foi selecionado!",
          },
          label: {
            pt: "País",
          },
          order: 3,
          options: {
            pt: [
              {
                code: "",
                name: "Selecione",
              },
              {
                code: "BR",
                name: "Brasil",
              },
              {
                code: "OU",
                name: "Outros",
              },
            ],
          },
        },
        expireAt: {
          error: {
            pt: "Em cartão de crédito, o campo data de validade não foi preenchido!",
          },
          label: {
            pt: "Data de validade",
          },
          order: 4,
          placeholder: {
            pt: "mm/aa",
          },
        },
        installments: {
          error: {
            pt: "Em cartão de crédito, o campo parcelas não foi preenchido!",
          },
          label: {
            pt: "Parcelas",
          },
          order: 6,
        },
      },
    }),
    email: JSON.stringify({
      body: {
        waiting: {
          en: "",
          es: "",
          pt: '<!DOCTYPE html> <html> <head> <meta charset="ISO-8859-7" /> <style type="text/css"> body { width: 873px; font-family: sans-serif; font-size: 20px; background-color: #ffffff; color: #000000; } p { margin: 10px; } img { width: 100%; } section p, a { margin: 4px 0px 0px 10px; } </style> <title>DEFAULT - Pedido de Ingresso</title> </head> <body class="{{defaultClass}}"> <img alt="DEFAULT" src="{{imgSrc}}" /> <p><strong>{{name}}</strong>,</p> <p>Obrigado por inscrever-se no EStadão Summit Imobiliário.</p> <p>Assim que o pagamento for confirmado, você receberá um e-mail de confirmação.</p> {{products}} <p><strong>Valor Total</p> <p>{{amount}} em {{installments}}x de {{installmentAmount}}, )}</p> <p>Ingresso pessoal e intransferí­vel.</p> </body> </html>',
        },
        confirmation: {
          en: "",
          es: "",
          pt: ' <!DOCTYPE html> <html> <head> <meta charset="ISO-8859-7" /> <style type="text/css"> body { width: 873px; font-family: sans-serif; font-size: 20px; background-color: #ffffff; color: #000000; } p { margin: 10px; } img { width: 100%; } .qr-code { width: 250px; } .qr-code-wrapper { max-width: 250px; border: 1px dashed black; } .qr-code-wrapper p{ text-align: center; } section p, a { margin: 4px 0px 0px 10px; } .attendees { margin: 15px 0px 0px 10px; } </style> <title>Default</title> </head> <body class="{{defaultClass}}"> <img alt="Default" src="{{imgSrc}}" /> <p><strong>Pagamento confirmado</strong> <p><strong>{{name}}</strong>, seu pagamento foi confirmado, encontre a seguir seu ingresso disponí­vel:</p> {{products}} <div class="attendees"> {{attendees}} </div> <p>Ingresso pessoal e intransferí­vel.</p> <p><strong>ESTADÃO SUMMIT IMOBILIÁRIO.</strong></p> <p> Dia xx de Junho de 2025</p> <p> Unibes Cultural </p> <p> Rua Oscar Freire, 2.500 </p> </p> <p> Te esperamos lá </p> </p> <p> Eventos Estadão </p> </body> </html>  ',
        },
      },
      subject: {
        waiting: {
          en: "",
          es: "",
          pt: "Pedido de Ingresso",
        },
        confirmation: {
          en: "",
          es: "",
          pt: "Pagamento confirmado",
        },
      },
      products: {
        en: "",
        es: "",
        pt: "<p>Ingresso:{{description}}</p>",
      },
      attendees: {
        es: "",
        pt: '<div class="qr-code-wrapper"> <p>{{name}}</p> <img class="qr-code" alt="QR Code de ${attendee.name}" src="https://qrcode.sistemasinteegra.com.br/?size=250&data={{id}}" /> <p>Ingresso intransferÃ­vel.</p> </div>',
        ent: "",
      },
    }),
    pix: JSON.stringify({
      title: {
        pt: "Pagamento instantâneo",
      },
      copied: {
        pt: "Copiado",
      },
      tocopy: {
        pt: "Copiar chave pix",
      },
      expired: {
        pt: "Pix expirado",
      },
      expirein: {
        pt: "Este pix expira em",
      },
    }),
    customer: JSON.stringify({
      fields: {
        name: {
          type: "alphabet",
          error: {
            pt: "O campo nome é obrigatório",
          },
          label: {
            pt: "Nome",
          },
          order: 1,
          required: true,
        },
        email: {
          type: "email",
          error: {
            pt: "O campo nome é obrigatório",
          },
          label: {
            pt: "E-mail",
          },
          order: 2,
          required: true,
        },
        address: {
          type: "default",
          error: {
            pt: "O campo nome é obrigatório",
          },
          label: {
            pt: "Endereço",
          },
          order: 4,
          required: false,
        },
        document: {
          type: "cpf_cnpj",
          error: {
            pt: "O campo nome é obrigatório",
          },
          label: {
            pt: "CPF/CNPJ",
          },
          order: 3,
          required: true,
        },
      },
      title_free: {
        pt: "de envio",
      },
      title_paid: {
        pt: "de cobrança",
      },
      title_start: {
        pt: "Dados",
      },
    }),
    promoCode: JSON.stringify({
      apply: {
        pt: "Aplicar",
      },
      title: {
        pt: "Cupom",
      },
    }),
    errors: JSON.stringify({
      generic: {
        pt: "Não foi possível finalizar a transação. Por favor, tente novamente!",
      },
      alreadybought: {
        pt: "Ingresso comprado anteriormente!",
      },
      emailalreadyadded: {
        pt: "E-mail já utilizado!",
      },
      promonotavailable: {
        pt: "Cupom utilizado não está mais disponível!",
      },
      productnotavailable: {
        pt: "Ingresso não está mais disponível!",
      },
      documentalreadyadded: {
        pt: "CPF já utilizado!",
      },
    }),
    messages: JSON.stringify({
      free: {
        title: {
          pt: "Cadastro realizado com successo!",
        },
        message: {
          pt: "Em breve você receberá o e-mail de confirmação",
        },
      },
      home: {
        title: {
          pt: "Venda de ingressos default",
        },
      },
      paid: {
        title: {
          pt: "Pagamento realizado com sucesso!",
        },
        message: {
          pt: "Em breve você receberá o e-mail de confirmação",
        },
      },
      attendee: {
        title_end: {
          pt: "participantes",
        },
        title_start: {
          pt: "Informações do",
        },
      },
    }),
    buttons: JSON.stringify({
      home: {
        pt: "Home",
      },
      cart_buy: {
        pt: "Comprar",
      },
      finish_buy: {
        pt: "Comprar",
      },
    }),
  };
};
